'use client';

/**
 * @module
 * @category Component
 */

import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/shared/image-grid/styles.module.css';
import { useParams } from 'next/navigation';
import type { CSSProperties } from 'react';

const srcset = (image: string, size: number, rows = 1, cols = 1) => {
  const width = size * cols;
  const height = size * rows;

  return {
    height,
    src: `${image}?w=${width}&h=${height}&fit=crop&auto=format`,
    srcSet: `${image}?w=${width}&h=${height}&fit=crop&auto=format&dpr=2 2x`,
    width,
  };
};

export type ImageGridProps = {
  items: ImageGridItem[];
};

export const ImageGrid = ({ items }: ImageGridProps) => {
  const params = useParams();
  const currentLanguage = getLanguageFromLocale(params.lang as string);

  return (
    <ul className={s.imageList}>
      {items.map(item => {
        const tile = srcset(item.img, 121, item.rows, item.cols);

        return (
          <li className={s.item} key={item.img} style={{ '--cols': item.cols || 1, '--rows': item.rows || 1 } as CSSProperties}>
            <img alt={item.title[currentLanguage]} className={s.itemImage} height={tile.height} loading='lazy' src={tile.src} srcSet={tile.srcSet} width={tile.width} />
            <div className={s.bar}>
              <div className={s.barTitleWrap}>
                <div className={s.barTitle}>{item.title[currentLanguage]}</div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
